// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // production: false,
  production: true,
  //developmentUrl: "http://148.72.215.184:8080/Travelance"
    // developmentUrl: "http://3.141.127.108/Travelance",
    //developmentUrl: "http://3.141.127.108:8080/Travelance",
     
  developmentUrl: "https://mytl.travelance.ca/Travelance",
    // developmentUrl: "https://thzretail.com/Travelance", 
  //developmentUrl:"https://b70ae643ec83.ngrok.io"
  firebase: {
    apiKey: "AIzaSyAJcBYq33QTCnO4c7oi3u-KxNliP_L7nNw",
    authDomain: "travelance-web.firebaseapp.com",
    projectId: "travelance-web",
    storageBucket: "travelance-web.appspot.com",
    messagingSenderId: "970698080167",
    appId: "1:970698080167:web:790804d43fe3e3ab430082",
    measurementId: "G-LB2S9W5DKL"
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
